import React, { Component } from 'react';
import {
  Card,
  CardHeader,
  CardBody,
  Button,
  CardFooter
} from 'reactstrap';
import {
  ComposableMap,
  ZoomableGroup,
  Geographies,
  Geography,
} from "react-simple-maps";
import { UncontrolledTooltip } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

class Map extends Component {
  constructor(props) {
    super(props);

    this.handleGeoClick.bind(this);
  }

  handleGeoClick(geoObj, province) {
    const { coreInsightId } = this.props;
    
    fetch('/api/prefectures?filter[name]=' + encodeURIComponent(geoObj.name)).then((resp) => resp.json())
      .then((respJson) => {
        respJson.data.forEach((item) => {
          fetch(item.relationships.province.links.related).then((resp) => resp.json())
            .then((respJson) => {
              if(respJson.data.attributes.name === province) {
                window.location.href = "/core_insights/insight/" + coreInsightId + 
                  "/prefecture/" + item.id;
              }
            });
        });
      });
  }

  getColor(province, geoName) {
    const { coreInsightValues, responseType } = this.props; 
    let color = "#ECEFF1";

    coreInsightValues.forEach((prefecture) => {
      if(prefecture.name === geoName && prefecture.province === province) {
        if(responseType === "interval") {
          switch(prefecture.interval) {
            case "high":      color = "#DC3545"; 
                              break;
            case "medium":    color = "#E25340";
                              break;
            case "moderate":  color = "#FFC107";
                              break;
            case "light":     color = "#29A645";
                              break;
            default:          break;
          } 
        } else {
          color = "#DC3545";
        }
      } 
    });

    return color;
  }

  getPrefectureCount() {
    const { coreInsightValues } = this.props; 
    let count = 0; 

    if(coreInsightValues) {
      coreInsightValues.forEach((prefecture) => {
        if(prefecture.value) {
          count++; 
        } 
      });
    }

    return count;
  }

  render() {
    const { coreInsightValues, responseType, intervals } = this.props;

    return (
      <Card className="mb-3">
        <CardHeader className="bg-primary text-white">
          <p className="my-auto">There are {this.getPrefectureCount()} prefectures represented in this Core Insight.</p>
        </CardHeader>
        <CardBody className="p-0">
          { coreInsightValues ?
            <div className="w-100 my-0 mx-auto">
              <ComposableMap
                projectionConfig={{
                  scale: 1000,
                  rotation: [-11,0,0],
                }}
                width={980}
                height={650}
                style={{
                  width: "100%",
                  height: "auto",
                }}
                >
                <ZoomableGroup center={[105,37]} disablePanning>
                  <Geographies geography={"/geographies/ChinaAllPrefectures.json"} disableOptimization>
                    {(geographies, projection) => geographies.map((geography, i) => {
                      if(geography.id !== "ATA") {
                        let defaultFill = "#ECEFF1";

                        if(geography.properties.notAvailable) {
                          return (
                            <Geography
                              key={i}
                              id={"geo-" + geography.properties.province.replace(/\s/g, '') + "-" + i}
                              geography={geography}
                              projection={projection}
                              style={{
                                default: {
                                  fill: defaultFill,
                                  stroke: "#215796",
                                  strokeWidth: 0.75,
                                  opacity: 0.3,
                                  outline: "none",
                                },
                                hover: {
                                  fill: defaultFill,
                                  stroke: "#215796",
                                  strokeWidth: 0.75,
                                  opacity: 0.3,
                                  outline: "none",
                                },
                                pressed: {
                                  fill: defaultFill,
                                  stroke: "#215796",
                                  strokeWidth: 0.75,
                                  opacity: 0.3,
                                  outline: "none",
                                },
                              }}
                            >
                              <UncontrolledTooltip placement="bottom" delay={0} target={"geo-" + geography.properties.province.replace(/\s/g, '') + "-" + i}>
                                {geography.properties.name} (Coming Soon)
                              </UncontrolledTooltip>
                            </Geography>
                          ); 
                        } else {
                          return (
                            <Geography
                              key={i}
                              id={"geo-" + geography.properties.province.replace(/\s/g, '') + "-" + i}
                              geography={geography}
                              projection={projection}
                              onClick={(geo) => this.handleGeoClick(geo.properties, geo.properties.province)}
                              style={{
                                default: {
                                  fill: coreInsightValues ? this.getColor(geography.properties.province, geography.properties.name) : defaultFill,
                                  stroke: "#215796",
                                  strokeWidth: 0.75,
                                  outline: "none",
                                },
                                hover: {
                                  fill: "#215796",
                                  stroke: "#215796",
                                  strokeWidth: 0.75,
                                  outline: "none",
                                },
                                pressed: {
                                  fill: "#e25241",
                                  stroke: "#215796",
                                  strokeWidth: 0.75,
                                  outline: "none",
                                },
                              }}
                            >
                              <UncontrolledTooltip placement="bottom" delay={0} target={"geo-" + geography.properties.province.replace(/\s/g, '') + "-" + i}>
                                {geography.properties.name}
                              </UncontrolledTooltip>
                            </Geography>
                          ); 
                        }
                      } 
                    })}
                  </Geographies>
                </ZoomableGroup>
              </ComposableMap>
            </div>
            :
            <div className="w-100 mt-5 mx-auto text-center">
              <FontAwesomeIcon icon={faSpinner} size="6x" spin className="text-center text-primary" />
            </div> }
        </CardBody>
        { responseType === "interval" ?
          <CardFooter>
            <h5>
              <span className="badge badge-pill badge-success mr-2">
                {intervals.light}
              </span>
              <span className="badge badge-pill badge-warning mr-2 text-white">
                {intervals.moderate}
              </span>
              <span className="badge badge-pill badge-secondary mr-2 text-white">
                {intervals.medium}
              </span>
              <span className="badge badge-pill badge-danger">
                {intervals.high}
              </span>
            </h5>
          </CardFooter>
        : null }
      </Card>
    ); 
  }
}

export default Map;
